import { render, staticRenderFns } from "./nearby-stores.vue?vue&type=template&id=5a500096&scoped=true"
import script from "./nearby-stores.vue?vue&type=script&lang=js"
export * from "./nearby-stores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a500096",
  null
  
)

export default component.exports